"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var client_1 = require("@apollo/client");
var __1 = require("..");
function GraphProvider(_a) {
    var children = _a.children, uri = _a.uri, cache = _a.cache;
    var auth = (0, react_1.useContext)(__1.AuthenticatorContext);
    var subdomain = /localhost|staged/gi.test(window.location.host) ? 'api-staged' : 'api';
    var authLink = new client_1.ApolloLink(function (operation, forward) {
        var _a;
        if (auth.user !== undefined) {
            var token = (_a = auth.user.getSignInUserSession()) === null || _a === void 0 ? void 0 : _a.getAccessToken().getJwtToken();
            var authorization = token ? "Bearer " + token : '';
            operation.setContext({
                headers: {
                    authorization: authorization,
                },
            });
        }
        return forward(operation);
    });
    var client = new client_1.ApolloClient({
        cache: cache || new client_1.InMemoryCache(),
        link: authLink.concat(new client_1.HttpLink({
            uri: uri || "https://" + subdomain + ".sport-thieme.io",
        })),
    });
    return react_1.default.createElement(client_1.ApolloProvider, { client: client }, children);
}
exports.default = GraphProvider;
//# sourceMappingURL=GraphProvider.js.map